import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, ListItemButton, ListItemText } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// Single clickable row inside a ReportSection.  Pass either `to` for
// internal navigation or `onClick` for action buttons (e.g. the
// "Download Site Listing" item that triggers an xlsx fetch).
export default function ReportLinkItem({ to, onClick, icon, primary, secondary }) {
  const linkProps = to ? { component: RouterLink, to } : { onClick };

  return (
    <ListItemButton
      {...linkProps}
      sx={{
        py: 1.25,
        px: 1.25,
        gap: 1.5,
        borderRadius: 'var(--radius-md)',
        color: 'text.primary',
        '&:hover': {
          backgroundColor: 'action.hover',
          '& .report-link-chevron': { color: 'primary.main', transform: 'translateX(2px)' },
        },
      }}
    >
      {icon ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            color: 'text.secondary',
            '& svg': { fontSize: 20 },
          }}
        >
          {icon}
        </Box>
      ) : null}
      <ListItemText
        primary={primary}
        secondary={secondary}
        primaryTypographyProps={{ fontSize: '0.95rem', fontWeight: 500 }}
        secondaryTypographyProps={{ fontSize: '0.8rem' }}
      />
      <ChevronRightIcon
        className="report-link-chevron"
        sx={{
          color: 'text.disabled',
          fontSize: 20,
          transition:
            'color var(--duration-normal) var(--easing-standard), transform var(--duration-normal) var(--easing-standard)',
        }}
      />
    </ListItemButton>
  );
}
